import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";

export const FX_RATES_KEY = ["fx-rates"] as const;

// CBR-курсы обновляются раз в сутки, на бэке шедулер таскает их не чаще,
// чем раз в 720 мин. Долгий staleTime безопасен — за 10 минут курс не уйдёт.
export function useFxRates() {
  return useQuery({
    queryKey: FX_RATES_KEY,
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/fx", { signal });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    staleTime: 10 * 60_000,
  });
}
